import { Illus, PrimaryButton } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../organisms/trans'
import { FullPage } from '../../../templates'
import { PolicyPath } from '../PolicyPath'

const tKey = TKey('pages.upload-confirmation')

export const UploadConfirmation: FunctionComponent = () => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const onContinue = useCallback(
    () => navigate(['..', '..', PolicyPath.DOCUMENTS].join('/')),
    [navigate],
  )

  return (
    <FullPage
      pageId='upload-confirmation'
      header={t(tKey('header'))}
      subheader={<WriskTrans i18nKey={tKey('subheader')} t={t} />}
      upperHeader={<Illus alt='Success' data-testid='bind-success' illus='bindSuccess' />}
    >
      <PrimaryButton onClick={onContinue} layout='fixed'>
        {t(tKey('actions.continue'))}
      </PrimaryButton>
    </FullPage>
  )
}
